import { render } from "./bzsj.vue?vue&type=template&id=233aa6fe&scoped=true"
import script from "./bzsj.vue?vue&type=script&lang=js"
export * from "./bzsj.vue?vue&type=script&lang=js"

import "./bzsj.vue?vue&type=style&index=0&id=233aa6fe&scoped=true&lang=scss"

import exportComponent from "E:\\project_copy_from_e\\项目\\后台\\cost_admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-233aa6fe"]])

export default __exports__